import { COMPANY } from "../data";

const items = ["Fundament tot eindafwerking", "Badkamers & keukens", "Stucwerk & schilderwerk", "Renovatie & onderhoud", "Glas zetten", "Hoofdaannemer sinds 2021"];

export const Marquee = () => {
  return (
    <div data-testid="marquee" className="bg-[var(--ink)] text-white py-6 overflow-hidden border-y border-black/10">
      <div className="animate-marquee">
        {[0, 1].map((dup) => (
          <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
            {items.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="font-display text-3xl md:text-5xl font-medium tracking-tight px-8">{t}</span>
                <span className="text-[var(--turq)] text-3xl md:text-5xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
